import { IonCol, IonImg, IonList, IonRow } from '@ionic/react';

// Components
import { Input } from '@/components/Input';
// Styles
import styles from '@/components/ProfileModal/ProfileModalContent.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

// Context
import { useAuthContext } from '@/contexts/authContext';
import { useUserInfoContext } from '@/contexts/userInfoContext';

interface ProfileModalProps {
  cleanUp?: () => void;
}

export const ProfileModalContent = ({ cleanUp }: ProfileModalProps) => {
  const user = useAuthContext().state.userState?.user;
  const { userInfo } = useUserInfoContext();

  const imgURL = new URL(`../../assets/clientProfileLogos/${userInfo.organization.logoURL}.png`, import.meta.url).href;

  return (
    <div className={styles.wrapper}>
      <IonRow className='ion-align-items-center ion-justify-content-center'>
        <IonCol className='ion-justify-content-center ion-text-center ' size='6'>
          <IonImg
            alt='Organization Logo'
            className=''
            src={imgURL}
            style={{ width: '75%', marginLeft: 'auto', marginRight: 'auto' }}></IonImg>
        </IonCol>
      </IonRow>
      <IonRow className='ion-align-items-center ion-justify-content-center' style={{ width: '100%' }}>
        <IonCol className='ion-margin-top' size='12'>
          <IonList class={mergeClassNames(styles['no-padding'], styles.list)} mode='md'>
            <Input
              disabled
              label='Name'
              labelPlacement='stacked'
              readonly={true}
              value={`${userInfo.firstName} ${userInfo.lastName}`}
              variant='light'
            />
            <br />
            <Input
              disabled
              label='Email'
              label-placement='stacked'
              readonly={true}
              value={user!.email!}
              variant='light'
            />
            <br />
            <Input
              disabled
              label='Organization'
              label-placement='stacked'
              readonly={true}
              value={userInfo.organization.org_name!}
              variant='light'
            />
          </IonList>
        </IonCol>
      </IonRow>
    </div>
  );
};
